const isNull = (value) => {
    if (value === null) { return true; }
    else { return false; }
};

export default isNull;
